<template>
  <div class="red-packet-modal flex ai-c" v-if="visible">
    <!-- 遮罩层 -->
    <div class="modal-overlay"></div>

    <!-- 初始红包弹窗 -->
    <div v-if="state === 'initial'" class="initial-popup w-100">
      <!-- 左侧烟花 -->
      <div
        v-if="leftFireworkShow"
        class="firework left-firework"
        :style="{ top: leftFireworkTop + '%' }"
      ></div>
      <!-- 右侧烟花 -->
      <div
        v-if="rightFireworkShow"
        class="firework right-firework"
        :style="{ top: rightFireworkTop + '%' }"
      ></div>

      <div class="red-packet" @click="startDraw">
        <img
          src="/static/images/redPackets/redpackets_open.png"
          class="red-packet-img m-auto"
          alt=""
        />
        <img
          src="/static/images/redPackets/redpackets_open_1.png"
          class="open-text m-auto mt40"
          alt=""
        />
        <img
          src="/static/images/redPackets/close.png"
          class="close m-auto mt40"
          @click.stop="close"
          alt=""
        />
      </div>
    </div>

    <!-- 3秒倒计时 -->
    <div v-if="state === 'countdown3'" class="countdown3-container w-100 pos-r zi-1">
      <!-- 左侧烟花 -->
      <div
        v-if="leftFireworkShow"
        class="firework left-firework"
        style="left: -8%; top: 0.2rem"
      ></div>
      <!-- 右侧烟花 -->
      <div
        v-if="rightFireworkShow"
        class="firework right-firework"
        style="right: -2%; top: 1rem"
      ></div>

      <img
        class="w-100 repackets_countdown"
        src="/static/images/redPackets/repackets_countdown.png"
        alt=""
      />
      <img
        class="w-30 m-auto repackets_countdown_1"
        src="/static/images/redPackets/repackets_countdown_1.png"
        alt=""
      />
      <div
        class="countdown3-number ta-c text-linear-gradient"
        :class="{ 'countdown3-animate': count3Animate }"
      >
        {{ countdown3Num }}
      </div>
    </div>

    <!-- 红包雨 -->
    <div v-if="state === 'rain'" class="rain-container w-100">
      <!-- 4秒倒计时 -->
      <div class="rain-header">
        <div
          class="countdown4-number text-linear-gradient"
          v-html="countdown4Num + `<span class='f20'>s</span>`"
        ></div>
        <img class="w-100" src="/static/images/redPackets/countdownbg.png" alt="" />
      </div>
      <div class="flex ml20 mt36 pos-a" style="top: 1rem">
        <img
          class="d-b"
          style="width: 0.34rem"
          src="/static/images/redPackets/redPackets_positive.png"
          alt=""
        />
        <div class="text-linear-gradient ml4 ta-l">
          <span class="f15 d-b">抽奖机会</span>
          <span class="f15 d-b">{{ drawResultInfo.drawNum || 0 }}次</span>
        </div>
      </div>

      <!-- 红包雨区域 -->
      <div class="rain-area">
        <div
          v-for="(packet, index) in redPackets"
          :key="index"
          class="falling-packet"
          :style="{
            left: `${packet.left}px`,
            top: `${packet.top}px`,
            transform: `rotate(${packet.rotate}deg)`,
            animationDelay: `${packet.delay}s`,
            opacity: packet.opacity,
            visibility: packet.visible ? 'visible' : 'hidden'
          }"
          @click="openPacket(index)"
        >
          <img
            :style="packet.showFireworks ? { visibility: 'hidden' } : {}"
            src="/static/images/redPackets/redPackets_positive.png"
            alt="红包"
            class="packet-img"
          />
          <!-- 烟花效果 (点击时显示) -->
          <div v-if="packet.showFireworks" class="fireworks"></div>
        </div>
      </div>
    </div>

    <!-- 抽奖结果 -->
    <div v-if="state === 'result'" class="result-container w-100">
      <div class="pos-r">
        <!-- 左侧烟花 -->
        <div
          v-if="leftFireworkShow"
          class="firework left-firework"
          style="left: -8%; top: 0.2rem"
        ></div>
        <!-- 右侧烟花 -->
        <div
          v-if="rightFireworkShow"
          class="firework right-firework"
          style="right: -2%; top: 1rem"
        ></div>
        <div
          v-if="drawResult.prizesType == 8"
          class="pos-a t0 w-100 ta-c"
          style="padding: 0.7rem 0.85rem 0; z-index: 6"
        >
          <p class="f18" style="color: #ab0000">恭喜您，抽中免单机会，</p>
          <span class="f16 color-29 d-b">
            您的{{ drawResult.orderNo }}订单免费，请截图联系客服为您做订单退款。
          </span>
        </div>
        <div
          v-else-if="drawResult.prizesType == 7"
          class="pos-a t0 w-100 ta-c"
          style="padding: 0.7rem 0 0; z-index: 6"
        >
          <p
            class="fw-b"
            style="color: #ab0000; font-size: 0.5rem"
            v-html="drawResult.giftAmount + `<span class='f18 font_w-n'>元</span>`"
          ></p>
        </div>
        <img
          :src="
            drawResultInfo.actStatus == 4
              ? '/static/images/redPackets/isgone_1.png'
              : drawResultInfo.actStatus == 5
              ? '/static/images/redPackets/isgone.png'
              : drawResult.prizesType == 7 || drawResult.prizesType == 8
              ? '/static/images/redPackets/' +
                (drawResult.prizesType == 7 ? 'moneybg' : 'freeorder') +
                '.png'
              : drawResult.prizeImg
          "
          alt="抽奖结果"
          class="result-image pos-r"
        />
        <div
          v-if="
            drawResult.prizesType == 2 ||
            drawResult.prizesType == 3 ||
            drawResult.prizesType == 6 ||
            drawResult.prizesType == 8
          "
          class="pos-a b0 btn w-100 flex"
          style="height: 0.34rem; margin-bottom: 0.49rem; z-index: 5"
        >
          <div class="flex-1 h-100" @click="leftBthHandle"></div>
          <div class="flex-1 h-100" @click="rightBthHandle"></div>
        </div>
        <div
          v-else
          class="pos-a b0 btn w-100 flex"
          style="height: 0.34rem; margin-bottom: 0.49rem; z-index: 5"
          @click="bthHandle"
        ></div>
      </div>
      <img
        src="/static/images/redPackets/close.png"
        class="close m-auto mt40"
        @click="close"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { kefu } from '../../assets/common/js/config'
export default {
  data() {
    return {
      state: 'initial', // 状态：initial, countdown3, rain, result
      countdown3Num: 3, // 3秒倒计时数字
      count3Animate: false,
      countdown4Num: 4, // 4秒倒计时数字
      scale: 1, // 3秒倒计时缩放比例
      redPackets: [], // 红包数组
      drawResultInfo: {}, // 抽奖结果信息
      drawResult: {}, // 抽奖结果
      rainTimer: null, // 红包雨计时器
      countdown3Timer: null, // 3秒倒计时计时器
      countdown4Timer: null, // 4秒倒计时计时器
      debounceTimer: null, // 防抖定时器
      debounceDelay: 10, // 防抖延迟时间（ms）
      leftFireworkTop: 0, // 左侧烟花垂直位置
      rightFireworkTop: 0, // 右侧烟花垂直位置
      leftFireworkShow: false, // 左侧烟花显示
      rightFireworkShow: false, // 右侧烟花显示
      fireworkPositionsTimer: null, //烟花位置定时器
      isDrawing: false, // 新增：是否正在抽奖中
      visible: false // 控制组件显示/隐藏
    }
  },
  methods: {
    open() {
      this.reset()
      this.visible = true
    },
    // 关闭组件
    close() {
      this.visible = false
      this.reset()
    },
    // 重置组件
    reset() {
      this.clearTimers()
      // 重置状态
      this.state = 'initial'
      this.countdown3Num = 3
      this.countdown4Num = 4
      this.redPackets = []
      this.isDrawing = false // 新增：重置抽奖状态
    },

    // 清除所有计时器
    clearTimers() {
      if (this.countdown3Timer) clearInterval(this.countdown3Timer)
      if (this.countdown4Timer) clearInterval(this.countdown4Timer)
      if (this.rainTimer) clearInterval(this.rainTimer)
      if (this.fireworkPositionsTimer) clearInterval(this.fireworkPositionsTimer)
    },

    // 开始抽奖
    async startDraw() {
      // 防止重复点击：如果正在抽奖中，直接返回
      if (this.isDrawing) return
      // 标记为正在抽奖
      this.isDrawing = true
      // 模拟调用接口获取抽奖结果
      try {
        // 实际项目中替换为真实接口调用
        const { data } = await this.$customRequestAjax.post(
          this.$ajax.getYearActivityDrawResult_URL
        )
        if (data.code == 200) {
          // 接口返回的抽奖结果
          this.drawResultInfo = data
          this.drawResult = data.prizes || {}
          if (this.drawResultInfo.actStatus == 1) {
            // 进入3秒倒计时状态
            this.state = 'countdown3'
            this.leftFireworkShow = false
            this.rightFireworkShow = false
            this.countdown3Num = 3
            this.startCountdown3()
            this.setRandomFireworkShow()
          } else if (this.drawResultInfo.actStatus == 3) {
            this.actStatusMsgHandle()
          } else if (this.drawResultInfo.actStatus == 4 || this.drawResultInfo.actStatus == 5) {
            this.endRedPacketRain()
          }
        } else {
          this.close()
        }
      } catch (error) {
        console.error('抽奖失败:', error)
        // 实际项目中添加错误处理
      } finally {
        // 无论成功失败，都解除抽奖中状态（如果需要允许重新抽奖）
        // 注意：如果进入倒计时后不允许再次触发，这里可以不重置
        // 根据业务需求调整，这里假设只有在初始状态才允许点击
        if (this.state === 'initial') {
          this.isDrawing = false
        }
      }
    },
    // 活动状态提示
    actStatusMsgHandle: function () {
      this.$dialog
        .alert({
          message: '活动已结束',
          className: 'percen_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(() => {
          // on close
          this.$app.goIndex()
        })
    },
    keFu: function () {
      kefu(1)
    },
    // 左侧按钮处理：去使用|去领取|联系客服
    leftBthHandle() {
      // 奖品：奖品|优惠券|产品券
      if (this.drawResult.prizesType == 2 || this.drawResult.prizesType == 6) {
        if (this.drawResult.link) {
          this.$app.argStaticLink(this.drawResult.link)
        } else {
          this.$app.goIndex()
        }
      } else if (this.drawResult.prizesType == 3) {
        this.$app.goPrize()
      } else if (this.drawResult.prizesType == 8) {
        this.keFu()
      }
    },
    // 右侧按钮处理：继续抽奖
    rightBthHandle() {
      if (this.drawResultInfo.drawNum > 0) {
        this.reset()
      } else {
        this.$app.argStaticLink(this.drawResultInfo.drawAgainLink)
      }
    },
    // 单独按钮：我知道了|继续抽奖
    bthHandle() {
      if (this.drawResultInfo.actStatus == 4) {
        this.$app.argStaticLink(this.drawResultInfo.drawAgainLink)
      } else if (this.drawResultInfo.actStatus == 5) {
        this.close()
      } else if (this.drawResult.prizesType == 7) {
        this.rightBthHandle()
      }
    },

    // 3秒倒计时
    startCountdown3() {
      const countdown = () => {
        this.count3Animate = true
        if (this.countdown3Num > 1) {
          setTimeout(() => {
            this.count3Animate = false
            setTimeout(() => {
              this.countdown3Num--
              // this.count3Animate = true
              countdown()
            }, 50)
          }, 1000)
        } else {
          setTimeout(() => {
            this.count3Animate = false
            this.state = 'rain'
            this.startRedPacketRain()
          }, 1000)
        }
      }

      countdown()
    },

    // 开始红包雨
    startRedPacketRain() {
      this.state = 'rain'
      this.countdown4Num = 4
      this.generateRedPackets()
      // 4秒倒计时
      this.countdown4Timer = setInterval(() => {
        this.countdown4Num--

        if (this.countdown4Num <= 1) {
          clearInterval(this.countdown4Timer)
          var Timer = setTimeout(() => {
            clearTimeout(Timer)
            this.endRedPacketRain()
          }, 1000)
        }
      }, 1000)

      // 红包下落动画
      this.rainTimer = setInterval(() => {
        this.updateRedPacketsPosition()
      }, 15)
    },
    // 初始化红包雨
    generateRedPackets() {
      this.redPackets = []
      const cols = 5 // 列数
      const rows = 5 // 行数
      const packetSize = 92 // 红包宽高
      const hGap = 10 // 水平间距(px)
      const vGap = 10 // 垂直间距(px)
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight

      // 矩阵旋转角度（0度）
      const rotationAngle = (45 * Math.PI) / 180

      // 计算单个红包占位大小（包含间距）
      const cellWidth = packetSize + hGap
      const cellHeight = packetSize + vGap

      // 计算矩阵原始中心点（未旋转时）
      const matrixCenterX = ((cols - 1) * cellWidth) / 2
      const matrixCenterY = ((rows - 1) * cellHeight) / 2

      // 计算旋转后矩阵的整体偏移量（用于居中）
      const totalRotatedWidth =
        Math.abs(cols * cellWidth * Math.cos(rotationAngle)) +
        Math.abs(rows * cellHeight * Math.sin(rotationAngle))
      const startLeft = (windowWidth * 2 - totalRotatedWidth) / 2
      const startTop = -windowHeight // 矩阵初始垂直位置（屏幕上方）
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          // 计算当前红包在原始矩阵中的位置（以矩阵中心为原点）
          const originalX = col * cellWidth - matrixCenterX
          const originalY = row * cellHeight - matrixCenterY

          // 应用旋转变换
          const rotatedX = originalX * Math.cos(rotationAngle) - originalY * Math.sin(rotationAngle)
          const rotatedY = originalX * Math.sin(rotationAngle) + originalY * Math.cos(rotationAngle)

          // 计算最终位置
          const left = startLeft + matrixCenterX + rotatedX
          const top = startTop + matrixCenterY + rotatedY

          // 按矩阵顺序设置延迟出现
          const delay = (row * cols + col) * 0.1

          // 生成5-10之间的随机下落速度（整数，包含3和8）
          const randomFallSpeed = Math.floor(Math.random() * 8) + 4 // 6种可能：5、6、7、8、9、10

          this.redPackets.push({
            left,
            top,
            initialTop: top,
            rotate: Math.random() * 40 - 20,
            delay,
            showFireworks: false,
            isOpen: false,
            visible: true,
            opacity: 0,
            swingDirection: Math.random() > 0.5 ? 1 : -1,
            swingAngle: 0,
            fallSpeed: randomFallSpeed // 使用3-8的随机速度
          })
        }
      }
    },

    // 更新红包位置和摇摆状态
    updateRedPacketsPosition() {
      // 清除上一次的防抖定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // 设置新的防抖定时器，延迟执行实际更新逻辑
      this.debounceTimer = setTimeout(() => {
        const windowHeight = window.innerHeight
        const fadeInDistance = 100
        const fadeOutDistance = 100
        const packetSize = 92 // 红包宽高

        this.redPackets = this.redPackets.map((packet) => {
          if (packet.isOpen) return packet

          // 下落速度使用红包自身的随机速度
          const newTop = packet.top + packet.fallSpeed
          // 摇摆角度变化
          let newSwingAngle = packet.swingAngle + packet.swingDirection
          // 摇摆方向反转
          if (Math.abs(newSwingAngle) > 4) {
            packet.swingDirection *= -1
            newSwingAngle = packet.swingAngle + packet.swingDirection
          }

          // 计算最终旋转角度 = 基础旋转 + 摇摆角度
          const newRotate = packet.rotate + newSwingAngle

          // 计算淡入效果：进入屏幕后逐渐显示
          let newOpacity = packet.opacity
          // 红包底部进入屏幕的距离
          const enterDistance = newTop + packetSize
          if (enterDistance > 0 && enterDistance <= fadeInDistance) {
            // 进入过程中，透明度从0到1
            newOpacity = enterDistance / fadeInDistance
          } else if (enterDistance > fadeInDistance) {
            // 完全进入屏幕后保持不透明
            newOpacity = 1
          }

          // 计算淡出效果：离开屏幕前逐渐消失
          const leaveDistance = windowHeight - newTop
          if (leaveDistance < fadeOutDistance && leaveDistance > 0) {
            // 离开过程中，透明度从1到0
            newOpacity = leaveDistance / fadeOutDistance
          } else if (newTop > windowHeight) {
            // 完全离开屏幕后隐藏
            return {
              ...packet,
              visible: false,
              opacity: 0
            }
          }

          return {
            ...packet,
            top: newTop,
            rotate: newRotate,
            swingAngle: newSwingAngle,
            opacity: newOpacity
          }
        })
      }, this.debounceDelay)
    },

    // 打开红包
    openPacket(index) {
      if (this.redPackets[index].isOpen) return

      // 显示烟花效果
      this.redPackets[index].showFireworks = true
      this.redPackets[index].isOpen = true
      // 1秒后隐藏烟花和红包
      setTimeout(() => {
        this.$set(this.redPackets[index], 'showFireworks', false)
        this.$set(this.redPackets[index], 'visible', false)
      }, 2000)
    },

    // 结束红包雨
    endRedPacketRain() {
      clearInterval(this.rainTimer)
      // 隐藏所有剩余红包
      this.redPackets.forEach((packet, index) => {
        this.$set(this.redPackets[index], 'visible', false)
      })

      // 短暂延迟后显示结果
      setTimeout(() => {
        this.leftFireworkShow = false
        this.rightFireworkShow = false
        this.state = 'result'
        this.setRandomFireworkShow()
      }, 500)
    },

    // 设置烟花随机位置
    setRandomFireworkPositions() {
      // 随机垂直位置 (-30% 到 30% 之间)
      this.fireworkPositionsTimer = setInterval(() => {
        this.leftFireworkTop = Math.floor(Math.random() * 92) - 30
        var Timer = setTimeout(() => {
          clearTimeout(Timer)
          this.rightFireworkTop = Math.floor(Math.random() * 92) - 30
        }, 500)
      }, 2000)
    },
    setRandomFireworkShow() {
      this.leftFireworkShow = true
      var Timer = setTimeout(() => {
        clearTimeout(Timer)
        this.rightFireworkShow = true
      }, 500)
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.clearTimers()
      } else if (newVal && this.state === 'initial') {
        // 当弹窗显示且处于初始状态时，设置烟花位置
        this.setRandomFireworkPositions()
        this.setRandomFireworkShow()
      }
    },
    state(newVal) {
      // 当回到初始状态时重新设置烟花位置
      if (newVal === 'initial' && this.visible) {
        this.setRandomFireworkPositions()
        this.setRandomFireworkShow()
      }
    }
  },
  mounted() {
    if (this.visible && this.state === 'initial') {
      this.setRandomFireworkPositions()
      this.setRandomFireworkShow()
    }
  },
  beforeDestroy() {
    this.clearTimers()
  }
}
</script>

<style scoped>
.red-packet-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

/* 遮罩层 */
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

/* 初始弹窗样式 */
.initial-popup {
  position: relative;
  z-index: 10;
}

/* 烟花样式 */
.firework {
  position: absolute;
  width: 1.2rem;
  height: 1.2rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 5;
  animation: firework 2s ease-in-out infinite;
}

.left-firework {
  left: 0;
  background-image: url('/static/images/redPackets/fireworks.png');
}

.right-firework {
  right: 0;
  background-image: url('/static/images/redPackets/fireworks.png');
}

/* 烟花动画 */
@keyframes firework {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.red-packet {
  position: relative;
  cursor: pointer;
  transition: transform 0.3s;
}

.red-packet-img {
  width: 97%;
}

/* open-text 缩放动画 */
.open-text {
  width: 62%;
  animation: scaleIn 0.7s ease-in-out infinite alternate;
}

@keyframes scaleIn {
  0% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1.1);
  }
}

.close {
  width: 0.4rem;
  height: 0.4rem;
}

/* 3秒倒计时样式 */
.countdown3-container {
  height: 100vh;
}
.repackets_countdown {
  min-height: 1.4rem;
}
.repackets_countdown_1 {
  min-height: 0.3rem;
}

.countdown3-number {
  font-size: 2.8rem;
  font-weight: bold;
  opacity: 0;
}

/* 3秒倒计时动画 */
.countdown3-animate {
  animation: count3Scale 1s ease-in-out;
}

@keyframes count3Scale {
  0% {
    transform: scale(1.5);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

/* 红包雨样式 */
.rain-container {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.rain-header {
  position: fixed;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  z-index: 15;
  text-align: center;
}

.countdown4-number {
  font-size: 0.3rem;
  font-weight: bold;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0.12rem;
}

.progress-bar {
  height: 0.08rem;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.04rem;
}

.rain-area {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.falling-packet {
  position: absolute;
  transition: top 0.05s linear, transform 0.1s ease-in-out, opacity 0.3s;
  z-index: 12;
  pointer-events: auto;
  cursor: pointer;
}

.packet-img {
  width: 0.92rem;
  height: 0.92rem;
  object-fit: contain;
}

/* 烟花效果 */
.fireworks {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1.2rem;
  height: 1.2rem;
  pointer-events: none;
  background-image: url('/static/images/redPackets/exploded.png');
  background-size: 1.2rem 1.2rem;
  animation: fireworks 0.5s ease-out forwards;
}

@keyframes fireworks {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}

/* 结果展示样式 */
.result-container {
  position: relative;
  z-index: 10;
}

.result-image {
  width: 90%;
  object-fit: contain;
  animation: popIn 0.5s cubic-bezier(0.18, 0.89, 0.32, 1.28);
  margin: auto;
  z-index: 5;
}

@keyframes popIn {
  0% {
    transform: scale(0);
  }
  70% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.close-btn {
  background-color: #e63946;
  color: white;
  border: none;
  padding: 0.1rem 0.24rem;
  border-radius: 0.2rem;
  font-size: 0.16rem;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 0.04rem -0.08rem rgba(0, 0, 0, 0.2);
}

.close-btn:hover {
  background-color: #d62828;
  transform: translateY(-0.02rem);
  box-shadow: 0 0.06rem 0.12rem rgba(0, 0, 0, 0.3);
}

.close-btn:active {
  transform: translateY(0);
  box-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.2);
}
.text-linear-gradient {
  background: linear-gradient(90deg, #ffffff 0%, #ffe390 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/common/redPacketsRainPop.vue